/* eslint-disable */
const isExternalLink = (url) => {
  return /^(https?:\/\/|mailto:)/.test(url);
};

export default isExternalLink;
